<template>
  <div class="snow-checkbox-group">
    <snow-checkbox
      v-for="option in options"
      class="mb-1"
      v-model="values[option.id]"
      v-bind="option"
      :size="size"
      :group-id="groupId"
      :key="option.id"
      @change="changeValue"
    >
      <slot :name="option.id" :option="option" />
    </snow-checkbox>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: () => "lg",
      validator: value => ["lg", "sm"].includes(value)
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      innerValue: this.value,
      values: {},
      groupId: this.id || `checkbox-group-${this._uid}`
    };
  },
  methods: {
    changeValue(v, id) {
      const isChecked = v === id;
      let newVal = isChecked
        ? [...this.innerValue, id]
        : this.innerValue.filter(_id => _id !== id);
      newVal = [...new Set(newVal)];
      this.innerValue = newVal;
      this.$emit("input", newVal);
    },
    setValues(val) {
      this.values = this.options.reduce((_values, option) => {
        const isIncluded = val.includes(option.id);
        _values[option.id] = isIncluded ? option.id : "";
        return _values;
      }, {});
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.innerValue = newVal;
        this.setValues(newVal);
      },
      deep: true
    }
  },
  mounted() {
    this.setValues(this.value);
  }
};
</script>
